import { useGetCurrency } from '@entities/currency';
import { useGetPaymentPeriod } from '@entities/paymentPeriod';
import {
  Flex,
  Loader,
  NumberInput,
  Select,
  Text,
  type NumberInputProps,
} from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

type CandidateResumeSalaryFieldProps = {
  salary: string;
  currencyId: string;
  paymentPeriodId: string;
  disabled?: boolean;
  onSalaryChange: (value: string) => void;
  onCurrencyChange: (value: string) => void;
  onPaymentPeriodChange: (value: string) => void;
};

export const CandidateResumeSalaryField = ({
  salary,
  currencyId,
  paymentPeriodId,
  disabled = false,
  onSalaryChange,
  onCurrencyChange,
  onPaymentPeriodChange,
}: CandidateResumeSalaryFieldProps) => {
  const { data: currencies, isLoading: isCurrencyLoading } = useGetCurrency();
  const { data: paymentPeriods, isLoading: isPaymentPeriodLoading } =
    useGetPaymentPeriod();
  const handleSalaryChange: NumberInputProps['onChange'] = value => {
    onSalaryChange(value.toString());
  };

  return (
    <Flex gap={24} pt={20} pb={16} direction='column' wrap='wrap'>
      <Flex direction='column' gap={6}>
        <Text fw={600}>Уровень дохода от</Text>
        <Text c='tertiary.7' size='sm'>
          Укажите зарплату, валюту и период выплаты
        </Text>
      </Flex>

      <Flex gap={16} wrap='wrap'>
        <NumberInput
          aria-label='Зарплата'
          placeholder='Сумма'
          variant='filled'
          value={salary}
          onChange={handleSalaryChange}
          decimalScale={0}
          disabled={disabled}
          flex='1 1 140px'
        />
        <Select
          aria-label='Валюта'
          placeholder='Валюта'
          variant='filled'
          value={currencyId || null}
          onChange={value => onCurrencyChange(value ?? '')}
          data={
            currencies?.map(currency => ({
              label: currency.code,
              value: currency.id.toString(),
            })) ?? []
          }
          rightSection={
            isCurrencyLoading ? (
              <Loader size='xs' />
            ) : (
              <IconChevronDown
                size={20}
                color='var(--mantine-color-primary-7)'
              />
            )
          }
          disabled={disabled || isCurrencyLoading}
          searchable
          clearable
          flex='1 1 120px'
        />
        <Select
          aria-label='Период выплаты'
          placeholder='Период'
          variant='filled'
          value={paymentPeriodId || null}
          onChange={value => onPaymentPeriodChange(value ?? '')}
          data={
            paymentPeriods?.map(period => ({
              label: period.name,
              value: period.id.toString(),
            })) ?? []
          }
          rightSection={
            isPaymentPeriodLoading ? (
              <Loader size='xs' />
            ) : (
              <IconChevronDown
                size={20}
                color='var(--mantine-color-primary-7)'
              />
            )
          }
          disabled={disabled || isPaymentPeriodLoading}
          searchable
          clearable
          flex='1 1 150px'
        />
      </Flex>
    </Flex>
  );
};
